var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpNavbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 1.33334C4.31804 1.33334 1.33337 4.31801 1.33337 8.00001C1.33337 11.682 4.31804 14.6667 8.00004 14.6667C11.682 14.6667 14.6667 11.682 14.6667 8.00001C14.6667 4.31801 11.682 1.33334 8.00004 1.33334ZM8.66671 12H7.33337V10.6667H8.66671V12ZM8.66671 9.23934V10H7.33337V8.66668C7.33337 8.48987 7.40361 8.3203 7.52864 8.19527C7.65366 8.07025 7.82323 8.00001 8.00004 8.00001C8.73537 8.00001 9.33337 7.40201 9.33337 6.66668C9.33337 5.93134 8.73537 5.33334 8.00004 5.33334C7.26471 5.33334 6.66671 5.93134 6.66671 6.66668H5.33337C5.33337 5.95943 5.61433 5.28116 6.11442 4.78106C6.61452 4.28096 7.2928 4.00001 8.00004 4.00001C8.70728 4.00001 9.38556 4.28096 9.88566 4.78106C10.3858 5.28116 10.6667 5.95943 10.6667 6.66668C10.6658 7.25656 10.4688 7.8294 10.1068 8.29511C9.74472 8.76083 9.23815 9.09298 8.66671 9.23934Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpNavbar);
export default __webpack_public_path__ + "static/media/help_navbar.fdaa7d6d5a20a61f24fd061b3f7a2040.svg";
export { ForwardRef as ReactComponent };